import { usePopover } from './hooks';
export var Popover = function (props) {
    return usePopover(props);
};
//# sourceMappingURL=Popover.js.map